module.exports = __webpack_public_path__ + "img/Speaker=Robin Orsini.631be35b.png";